export const theme = {
  bg: '#0f0f1a',
  card: '#1a1a2e',
  cardHover: '#22223a',
  border: '#2d2d4a',
  text: '#e2e8f0',
  textMuted: '#94a3b8',
  accent: '#6366f1',
  accentHover: '#818cf8',
  success: '#22c55e',
  successBg: '#052e16',
  warning: '#eab308',
  warningBg: '#422006',
  error: '#ef4444',
  errorBg: '#450a0a',
  tableHeader: '#1e1e32',
  tableRow: '#151528',
  tableRowAlt: '#1a1a30',
  input: '#1e1e32',
  inputBorder: '#3d3d5c',
  statusOn: { bg: '#052e16', color: '#22c55e' },
  statusOff: { bg: '#450a0a', color: '#ef4444' },
};
